import GraphQL from './ConsultaGraphQL';

import url from '../../../../../apiService/ApiUrl.js';

// JavaScript Document
function handleError(err, This){
	console.log(`Request failed: ${err}`);
	This.setState({
		updateEmpresaMensaje: {
			response: 'failure',
			mensaje: `Hubo un error, el error fué: ${err}, intenta de nuevo`
		}
	})
}

const updateProyecto = (This, proyectoJSON) => {
	const options = {
		method: 'post',
		headers: {
			"Content-type": "application/json"
		},
		body: JSON.stringify(GraphQL(proyectoJSON)),
		credentials: 'include'
	}

	//llamada de datos con Fetch
	fetch(url, options)
	.then(res => res.json())
	.then( (res) => {
		//console.log(res)
		This.setState({
			updateProyectoMensaje: {
				response: 'success',
				mensaje: res.data.updateProyecto.mensaje
			}
		})
		return res
	})
	.catch(err => handleError(err, This));

	//termina fetch
}

export default updateProyecto;
